import { NSARouterMakerResult, NSAHomePage } from 'namirasoft-account-react';
import { NotificationSenderLayout } from '../NotificationSenderLayout';
import { NotificationSenderProps } from '../NotificationSenderProps';

interface HomePageProps extends NSARouterMakerResult, NotificationSenderProps { }

export default function HomePage(props: HomePageProps)
{
	return (
		<NotificationSenderLayout
			{...props}
		>
			<NSAHomePage
				{...props}
			/>
		</NotificationSenderLayout>
	);
}